import { render } from "./EmailSvg.vue?vue&type=template&id=21c1a83d"
import script from "./EmailSvg.vue?vue&type=script&lang=js"
export * from "./EmailSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__